import React, { PureComponent } from 'react';
import {
    LineChart, XAxis, YAxis, CartesianGrid,
    Tooltip, ResponsiveContainer, Customized,
    Rectangle, Line, ReferenceLine
} from 'recharts';
import './DRChart.css';
import { PrettyDate } from '../../helpers/DateHelper';

const gahpWidth = 5;

const CustomizedRectangle = (props) => {
    const { formattedGraphicalItems } = props;
    // get first and second series in chart
    const firstSeries = formattedGraphicalItems[0];
    const secondSeries = formattedGraphicalItems[1];
    const opens = formattedGraphicalItems[2];
    const closes = formattedGraphicalItems[3];

    // render custom content using points from the graph
    return firstSeries?.props?.points.map((firstSeriesPoint, index) => {
        const secondSeriesPoint = secondSeries?.props?.points[index];
        var yDifference = firstSeriesPoint.y - secondSeriesPoint.y + 1;

        if(firstSeries.y === 0 && secondSeriesPoint.y === 0) yDifference = 0;

        const openClose = closes?.props?.points[index].y - opens?.props?.points[index].y;

        return (
            <Rectangle
                key={firstSeriesPoint.payload.date}
                width={1}
                height={yDifference}
                x={secondSeriesPoint.x}
                y={secondSeriesPoint.y}
                fill={openClose < 0 ? '#52C41A' : '#F5212D'}
            />
        )
    })
};

const CustomizedRectangle2 = (props) => {
    const { formattedGraphicalItems } = props;
    // get first and second series in chart
    const firstSeries = formattedGraphicalItems[2];
    const secondSeries = formattedGraphicalItems[3];

    // render custom content using points from the graph
    return firstSeries?.props?.points.map((firstSeriesPoint, index) => {
        const secondSeriesPoint = secondSeries?.props?.points[index];
        const yDifference = firstSeriesPoint.y - secondSeriesPoint.y + 1;

        const openClose = secondSeriesPoint.y - firstSeriesPoint.y;

        return (
            <Rectangle
                key={firstSeriesPoint.payload.date}
                width={gahpWidth}
                height={yDifference}
                x={secondSeriesPoint.x - Math.floor(gahpWidth / 2)}
                y={secondSeriesPoint.y}
                fill={openClose < 0 ? '#52C41A' : '#F5212D'}
            />
        )
    })
};

const CustomizedRectangleVolunm = (props) => {
    const { formattedGraphicalItems, height, offset, data } = props;
    var maxHeight = 100;
    const firstSeries = formattedGraphicalItems[2];
    const secondSeries = formattedGraphicalItems[3];

    var minVolume = data.reduce((prev, curr) => prev.volume < curr.volume ? prev : curr).volume;
    var maxVolume = data.reduce((prev, curr) => prev.volume > curr.volume ? prev : curr).volume;
    var gap = maxVolume - minVolume;

    return firstSeries?.props?.points.map((firstSeriesPoint, index) => {
        const secondSeriesPoint = secondSeries?.props?.points[index];

        const openClose = secondSeriesPoint.y - firstSeriesPoint.y;
        var volume = data[index].volume ;
        var heightPercent = ((volume - minVolume)/gap) * 100;
        var barHeight = (maxHeight * .1) + ((maxHeight * .9) * heightPercent / 100);
        barHeight = Math.floor(barHeight);

        return (
            <Rectangle
                key={firstSeriesPoint.payload.date}
                width={gahpWidth}
                height={barHeight}
                x={firstSeriesPoint.x - Math.floor(gahpWidth/ 2)}
                y={height - barHeight - offset.bottom}
                fill={openClose < 0 ? '#52C41A' : '#F5212D'}
                opacity={0.5}
            />
        )
    })
};

const CustomLabel = (props) => {

    return <foreignObject width={60} height={20} className="label-wrapper"
        offset={props.offset}
        x={props.viewBox?.width +5}
        y={props.viewBox?.y - 10}>
        <div xmlns="http://www.w3.org/1999/xhtml" className="custom-chart-tag">
            <span className='custom-chart-tag-head'>

            </span>
            <span className='custom-chart-tag-text'>
                {parseFloat(props.value).toFixed(2)}
            </span>
        </div>
    </foreignObject>
}

const CustomTooltip = (props) => {
    var { active, payload } = props;
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
            <span>{PrettyDate(payload[0].payload.date, 'dd/MM/yyyy')}</span>
            <span>High: {payload[0].payload.high.toFixed(2)}</span>
            <span>Low: {payload[0].payload.low.toFixed(2)}</span>
            <span>Open: {payload[0].payload.open.toFixed(2)}</span>
            <span>Close: {payload[0].payload.close.toFixed(2)}</span>
        </div>
      );
    }
  
    return null;
  };

export default class DRChart extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: true
        };
    }

    async loadContent(url) {
        try {
            const response = await fetch(url);
            const data = await response.json();
            return data;
        }
        catch {
            console.log("Error");
            return [];
        }
    }

    async loadMarketDataChart(symbol) {
        if (symbol !== "") {
            var url = 'api/MarketData/GetDRDailyInfo?symbol=' + symbol + '&recordToTake=' + 90;
            var result = await this.loadContent(url);
            this.setState({ data: result, isLoading: false });
            if (result.length > 0) {
                this.data = result;
            } else {
                this.data = [
                    {
                        high: 0.00,
                        low: 0.00,
                        open: 0.00,
                        close: 0.00,
                        volume: 0,
                        lastPrice: 0.00,
                        date: 0,
                    }
                ];
            }
        }            
    }
    

    async componentDidMount() {
        await this.loadMarketDataChart(this.props.symbol);
    }

    async componentDidUpdate(previosProps) {
        if (this.props.symbol !== "" && previosProps.symbol !== this.props.symbol) {
            await this.loadMarketDataChart(this.props.symbol);
        }         
    }

    static renderChart(data,lastPrice) {
        var ticks = [];

        if (data && data.length > 2) {
            var firstIndex = 1;
            var middleIndex = Math.floor(data.length / 2);
            var lastIndex = data.length - 1;
            if (firstIndex === middleIndex) {
                firstIndex = 0;
            }                
            ticks.push(data[firstIndex].date);
            ticks.push(data[middleIndex].date);
            ticks.push(data[lastIndex].date);
        } else {            
            for (var i = 0; i < 3; i++) {
                ticks.push({ date: "" });
            }
        }
        return (
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    width={500}
                    height={200}
                    data={data}
                    margin={{
                        top: 20,
                        right: 0,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid horizontal={true} vertical={false} stroke='rgba(0, 0, 0, 0.09)' />
                    <XAxis
                        dataKey="date"
                        axisLine={false}
                        tickLine={false}
                        style={{ fontSize: '14px' }}
                        ticks={ticks}
                        padding={{ right: 16, left: 16 }}
                        interval={0}
                        tickFormatter={tick => PrettyDate(tick)}
                        //scale='time'
                    />
                    <YAxis
                        orientation='right'
                        axisLine={{ stroke: 'rgba(0, 0, 0, 0.09)' }}
                        tickSize={0.1}
                        allowDecimals={true}
                        domain={['auto', 'auto']}
                        style={{ fontSize: '14px' }}
                        dataKey='open'
                        padding={{ bottom: 120 }}
                        tickFormatter={tick => tick.toFixed(2)}
                        dx={20}
                    />
                    <Tooltip
                        allowEscapeViewBox={{ x: false, y: false }}
                        content={<CustomTooltip />}
                        position={{ x: 0, y: 20 }}
                        dot={false}
                    />
                    <Line type="monotone" dataKey="high" stroke={0} activeDot={false} dot={false} />
                    <Line type="monotone" dataKey="low" stroke={0} activeDot={false} dot={false} />
                    <Line type="monotone" dataKey="open" stroke={0} activeDot={false} dot={false} />
                    <Line type="monotone" dataKey="close" stroke={0} activeDot={false} dot={false} />
                    <Customized component={CustomizedRectangle} />
                    <Customized component={CustomizedRectangle2} />
                    <Customized component={CustomizedRectangleVolunm} />
                    <ReferenceLine
                        y={lastPrice}
                        stroke='#52C41A' strokeDasharray="5 5"
                        label={<CustomLabel value={lastPrice} />} />
                </LineChart>
            </ResponsiveContainer>
        );

    }

    render() {
        if (this.state.isLoading) {
            return <p><em>Loading Chart ...</em></p>;
        } else {
            return DRChart.renderChart(this.data, this.props.lastPrice);
        }        
    }
}
